import { render } from "./GoalSetter.vue?vue&type=template&id=56715cf7"
import script from "./GoalSetter.vue?vue&type=script&lang=js"
export * from "./GoalSetter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__